import { render, staticRenderFns } from "./PaintModeButton.vue?vue&type=template&id=5ac85bd4&scoped=true&"
import script from "./PaintModeButton.vue?vue&type=script&lang=js&"
export * from "./PaintModeButton.vue?vue&type=script&lang=js&"
import style0 from "./PaintModeButton.vue?vue&type=style&index=0&id=5ac85bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac85bd4",
  null
  
)

export default component.exports